import type { Position } from './types';

export const POSITIONS: { key: Position; label: string }[] = [
  { key: 'top', label: 'Top' },
  { key: 'jungle', label: 'Jungle' },
  { key: 'mid', label: 'Mid' },
  { key: 'bot', label: 'Bot' },
  { key: 'support', label: 'Support' },
];

/**
 * Maps a lane/position to the champion class tags that typically play it.
 *
 * Positions aren't in Data Dragon (and champions flex across lanes), so this is a
 * pragmatic heuristic: when you pick your role, recommendations for your team are
 * narrowed to champions carrying at least one of these tags.
 */
export const POSITION_TAGS: Record<Position, string[]> = {
  top: ['Fighter', 'Tank'],
  jungle: ['Fighter', 'Tank', 'Assassin'],
  mid: ['Mage', 'Assassin'],
  bot: ['Marksman'],
  support: ['Support', 'Tank', 'Mage'],
};
